<template>
  <div>
    <div class=" container-fluid   ">
      <div class="llp-container-section  heightcontainer ">
        <top-header id="height2"></top-header>
        <main-menu id="height3"></main-menu>
        <!-- Start the code for this screen here -->
        <div id="deals" class=" container-fluid menu-margin-top" style="padding-left:0px;padding-right:0px">
          <div>
            <nav class="navbar navbar-expand-lg  bg-info text-white">
              <span><b> Add Application</b></span>
            </nav>
            <center v-if="applicationtype === convertQuote"><span :style="msgcolor"><b>{{ information }}</b></span></center>
            <center v-if="applicationtype === newapp"><span :style="msgcolor"><b>{{ information }}</b></span></center>
            <br>
            <input type="radio" v-model="applicationtype" class="ml-3" v-bind:value="newapp" @click="resetEntries"> New
            Application
            <input type="radio" v-model="applicationtype" class="ml-3" v-bind:value="convertQuote"
              @click="resetEntries" @change="quotesSearch"> Convert From Quote
            <div v-if="applicationtype === convertQuote">
              <br>

              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Quote Number</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedQuoteNumber"
                  :options="quoteNumbersList" :value="quoteNumbersList" selected="selected" id="customersdd">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="quote" class="col-form-label col-form-label-sm required"> Date Range </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="fromDate" v-validate="'required'" class="form-control input-sm"
                  name="DFrom" data-vv-as="Date Range" />
                <div v-if="errors.has('DFrom')" class="alert-danger"> {{ "Date Range is Mandatory" }} </div>
              </div>
              <!-- <div class="col-sm-6 d-none d-sm-block d-md-none">
              </div> -->
              <div
                class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input type="Date" v-model.trim="toDate" class="form-control input-sm" v-validate="'required'"
                  name="DFrom" data-vv-as="Date Range" />
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Underwriter Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCreditAnalystId"
                  :options="creditAnalystList" :value="creditAnalystList.employeeId"
                  :custom-label="displayFullName" selected="selected" id="creditAnalyst">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Salesperson Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedAgentId"
                  :options="agentList" :value="agentList.employeeId" :custom-label="displayFullName"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer Name</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerId"
                  :options="quoteDealersList" :value="quoteDealersList.dealerId" :custom-label="displayDealerFullName"
                  selected="selected" id="customersdd" @input="getDealerDetails(selectedDealerId.dealerId, 'search')">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Lessee Name</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedCustomerId"
                  :options="quoteCustomersList" :value="quoteCustomersList.customerId"
                  :custom-label="displayCustomerFullName" @input="getFraudLessee(selectedCustomerId.customerId)"
                  selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason != null">
                  <label class="col-form-label col-form-label-sm">Dealer Fraud Reason</label>
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="searchDealerFraudReason != null && searchDealerFraudReason != 'Review'">
                  <label v-if="searchDealerFraudReason == ''" style="background-color:Yellow; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">Reason not available</label>
                  <label v-if="searchDealerFraudReason != ''" style="background-color:Red; text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{searchDealerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason != null && searchDealerFraudReason == 'Review'">
                  <label style="background-color:Orange;text-align:center; float:left"
                    class="col-form-label col-form-label-sm">{{searchDealerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="searchDealerFraudReason == null">
                </div>
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="searchDealerFraudReason == null">
                </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="customerFraudReason != null && customerFraudReason.length">
                <label class="col-form-label col-form-label-sm">Lessee Fraud Reason</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                v-if="customerFraudReason != null && customerFraudReason != 'Review'">
                <label style="background-color:Red; text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ customerFraudReason }}</label>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                v-if="customerFraudReason != null && customerFraudReason == 'Review'">
                <label style="background-color:Orange;text-align:center; float:left"
                  class="col-form-label col-form-label-sm">{{ customerFraudReason }}</label>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Dealer State</label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="selectedDealerState"
                  :options="quoteDealerStateList" :value="quoteDealerStateList.stateFipsC"
                  :custom-label="displayStateFullName" selected="selected" id="customersdd">
                </multiselect>
              </div>
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Year </label>
              </div>
              <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteYear" :options="quoteYearList"
                  :value="quoteYearList" selected="selected" id="customersdd">
                </multiselect>
              </div>

            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Make</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteMake" :options="quoteMakeList"
                  :value="quoteMakeList" selected="selected" id="customersdd">
                </multiselect>
              </div>

              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Model</label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <multiselect style="width:100%" name="proposedLessee" v-model="quoteModel" :options="quoteModelList"
                  :value="quoteModelList" selected="selected" id="customersdd">
                </multiselect>
              </div>
            </div>
            <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                <label for="source" class="col-form-label col-form-label-sm">Quote Status </label>
              </div>
              <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <select v-model="quoteStatus" class="form-control input-sm">
                  <option value="All">All</option>
                  <option v-for="(option, index) in status" :value="option.status" :key="index">{{ option.status }}
                  </option>
                </select>
              </div>
            </div>
              <br>
            <center>

              <button type="submit" @click="quotesSearch" class="btn btn-secondary mb-2 mr-3">Search</button>

              <button type="submit" @click="resetEntriesAndSearch" class="btn btn-secondary mb-2 mr-3">Reset</button>

            </center>
            <br>
              <div class="row p-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive table-responsive-sm" style="overflow:auto;">
                    <v-table id="myappsTable" :data="listQuotes" :pageSize="25"
                      @totalPagesChanged="totalPages = $event" class="table table-sm table-bordered table-striped">
                      <thead class="table-month-header-blue wrap-text" slot="head">
                        <v-th sortKey="lmQuoteId">Select</v-th>
                        <v-th sortKey="businessContactFullName">Bussiness Contact Name</v-th>
                        <v-th sortKey="lmProposedLesseeName">Lessee Name</v-th>
                        <v-th sortKey="fraudreason">Customer Fraud Reason</v-th>
                        <v-th sortKey="lmQuote">Quote Generated Date</v-th>
                        <v-th sortKey="lmQuoteId">Quote Number</v-th>
                        <v-th sortKey="lmMake">Make</v-th>
                        <v-th sortKey="lmModel">Model</v-th>
                        <v-th sortKey="lmLoanAmount">Loan Amount</v-th>
                        <v-th sortKey="lmDealerName">Dealer Name</v-th>
                        <v-th sortKey="lmQuoteStatus">Quote Status</v-th>
                      </thead>
                      <tbody slot="body" slot-scope="{ displayData }">
                        <tr v-for="(quote, index) in displayData" :class="colorRow(quote.lmQuoteId)">
                          <td> <input type="radio" v-model="selectedquote"
                              @click="populateQuoteValues(quote.lmQuoteId, index)" v-bind:value="quote.lmQuoteId"> </td>
                          <td>{{ quote.lmProposedLesseeName }}</td>
                          <td>{{ quote.businessContactFullName }}</td>
                          <td class="table-month-td"
                            v-if="quote.fraudreason != 'Review' && (quote.fraudreason != null && quote.fraudreason.length > 0)"
                            style="background-color: Red">{{ quote.fraudreason }} </td>
                          <td class="table-month-td"
                            v-if="quote.fraudreason == 'Review' && (quote.fraudreason != null && quote.fraudreason.length > 0)"
                            style="background-color: Orange">{{ quote.fraudreason }} </td>
                          <td class="table-month-td" v-if="quote.fraudreason == null">{{ quote.fraudreason }} </td>
                          <td>{{ quote.lmQuote | moment("MM/DD/YYYY") }}</td>
                          <td>{{ quote.lmQuoteId }}</td>
                          <td>{{ quote.lmMake }}</td>
                          <td>{{ quote.lmModel }}</td>
                          <td>{{ quote.lmLoanAmount }}</td>
                          <td>{{ quote.lmDealerName }}</td>
                          <td>{{ quote.lmQuoteStatus }}</td>

                        </tr>
                      </tbody>
                    </v-table>
                    <b-pagination v-if="totalPages > 0"  
                      align="right"
                      v-model="currentPage"
                      :total-rows="totalElements"
                      :per-page="perPage"
                      aria-controls="myappsTable"
                      @change="handleClick($event)"
                      :class="{ 'd-none': isLoading || listQuotes.length == 0 }">
                    </b-pagination>
                    <template v-if="listQuotes.length == 0 && !isLoading">
                      <center>
                          <span>
                              <b>No records found</b>
                              <br />
                          </span>
                      </center>
                  </template>
                  <template v-if="isLoading">
                        <div class="d-flex justify-content-center align-items-center">
                          <strong>Loading...</strong>
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                  </template>
                  </div>
                </div>
              </div><!-- col end-->
            </div><!--row end-->
            <div v-if="applicationtype === newapp || selectedquote != ''">
              <br>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="appDate" class="col-form-label col-form-label-sm "> App Date </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                  <label for="appDate" class="col-form-label col-form-label-sm "> {{ application.appDate |
              moment("MM/DD/YYYY") }} </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="lesseeName" class=" col-form-label col-form-label-sm required"
                    v-if="applicationtype === newapp"> Lessee Name </label>
                  <label for="lesseeName" class="col-form-label col-form-label-sm  required" v-else>Modified Lessee Name
                  </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">

                  <multiselect style="width:100%" name="proposedLessee" ref="proposedLessee" v-validate="'required'"
                    data-vv-as="Lessee Name" v-model="selectedCustomerData" :options="customersList"
                    :value="customersList.customerId" :custom-label="displayCustomerFullName"
                    @input="getCustomerDetails(selectedCustomerData.customerId)" selected="selected" id="customersdd">
                  </multiselect>
                  <div v-if="errors.has('proposedLessee')" class="alert-danger">{{ errors.first('proposedLessee') }}
                  </div>
                </div><!-- col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="application.customerFraudReason != null">
                  <label class=" col-form-label col-form-label-sm">Lessee Fraud Reason</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="application.customerFraudReason != null && application.customerFraudReason != 'Review'">
                  <label style="background-color:Red; text-align:center;float:left"
                    class=" col-form-label col-form-label-sm">{{ application.customerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="application.customerFraudReason != null && application.customerFraudReason == 'Review'">
                  <label style="background-color:Orange; text-align:center;float:left"
                    class=" col-form-label col-form-label-sm">{{ application.customerFraudReason }}</label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="creditAnalyst" class="col-form-label col-form-label-sm required">Underwriter Name</label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect style="width:100%" name="creditAnalyst" ref="creditAnalyst" v-validate="'required'"
                    data-vv-as="Credit Analyst" v-model="selectedCreditAnalystData" :options="creditAnalystList"
                    :value="creditAnalystList.employeeId" :custom-label="displayFullName"
                    @input="getAgentDetails(selectedCreditAnalystData.employeeId, 'CA')"
                    selected="selected" id="creditAnalyst">
                  </multiselect>
                  <div v-if="errors.has('creditAnalyst')" class="alert-danger">{{ errors.first('creditAnalyst') }}</div>
                </div><!-- col end-->
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="salesperson" class="col-form-label col-form-label-sm  required"> Salesperson Name </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect style="width:100%" name="salesperson" ref="salesperson" v-validate="'required'"
                    data-vv-as="Salesperson" v-model="selectedEmployeeData" :options="agentList"
                    :value="agentList.employeeId" :custom-label="displayFullName"
                    @input="getAgentDetails(selectedEmployeeData.employeeId, 'SR'), updateDealer(selectedEmployeeData.employeeId)"
                    selected="selected" id="salesperson">
                  </multiselect>
                  <div v-if="errors.has('Salesperson')" class="alert-danger">{{ errors.first('Salesperson') }}</div>
                </div><!-- col end-->

                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="source" class="col-form-label col-form-label-sm  required"> Source </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select name="source" ref="source" v-model.trim="application.source" class="form-control input-sm "
                    v-validate="'required'" data-vv-as="Source" @change="updateDealer">
                    <option disabled value=""> Select a Source</option>
                    <option v-for="(option, index) in sources" :value="option.sourceName" :key="index">{{
              option.sourceName }}</option>
                  </select>
                  <div v-if="errors.has('source')" class="alert-danger">{{ errors.first('source') }}</div>
                </div><!-- col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="dealerName" class="col-form-label col-form-label-sm "> Dealer Name </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect style="width:100%" name="dealerName" v-model="selectedDealerData"
                    :options="sortedDealers" :value="sortedDealers.dealerId" label="dealerName"
                    @input="getDealerDetails(selectedDealerData.dealerId)" selected="selected" id="customersdd">
                  </multiselect>
                </div><!-- col end-->
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="stateCode" class="col-form-label col-form-label-sm "> State of Reg</label>
                </div><!-- col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect style="width:100%" name="proposedLessee" v-model="selectedApplicationStateData"
                    :options="states" :value="states.stateAlphaC" label="stateN" selected="selected" id="customersdd">
                  </multiselect>
                </div><!-- col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="loanamount" class="col-form-label col-form-label-sm "> Loan Amount </label>
                </div><!-- col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="loanamount" v-validate="'decimal:2'" data-vv-as="Loan Amount"
                    v-model.trim="application.loanamount" placeholder="Enter Amount" class="form-control input-sm "
                    onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                  <div v-if="errors.has('loanamount')" class="alert-danger">{{ errors.first('loanamount') }}</div>
                </div><!-- col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label id="custTypedd" class="col-form-label col-form-label-sm "> Customer type</label>
                </div>
                <div class="col d-flex align-items-center">
                  <label for="year"> {{ customerType | formatCustType }} </label>
                </div><!-- col end-->
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="probability" class="col-form-label col-form-label-sm ">Deal closing probability%</label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select name="probability" v-model.trim="application.dealClosingProbabilityPercent"
                    class="form-control input-sm ">
                    <option v-for="probability in dealClosingProbabilityPercentList" v-bind:key="probability.key">
                      {{ probability.value }} </option>
                  </select>
                </div><!--col end-->
                <template v-if="application.source === 'InHouse'">
                  <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label for="InhouseName" class="col-form-label col-form-label-sm "> Inhouse Values</label>
                  </div>
                  <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                    <select name="InhouseName" v-model.trim="application.inHouseName" class="form-control input-sm ">
                      <option disabled value=""> Select a Inhouse value </option>
                      <option v-for="(option, index) in inhouseList" :value="option.inhouseValue" :key="index">{{
              option.inhouseValue }}</option>
                    </select>
                  </div>
                </template>
              </div><!--col end-->
            </div><!-- row end-->
            <br>
            <div v-if="applicationtype === newapp || selectedquote != ''">
              <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Vehicle Information</b></span></nav>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="currentMiles"> Vin Number </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="Vin Number" v-validate="'min:6'" class="form-control input-sm "
                    data-vv-as="Vin Number" v-model.trim="application.vinNumber"
                    placeholder="Enter Min Last 6 characters" @input="getVinFraudReason(application.vinNumber)">
                  <div v-if="errors.has('Vin Number')" class="alert-danger">{{ errors.first('Vin Number') }}</div>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="application.vinNumber != '' && application.vinFraudReason != null">
                  <label for="currentMiles"> Vin Fraud Reason </label>
                </div>
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center"
                  v-if="application.vinNumber != '' && application.vinFraudReason != null">
                  <label for="currentMiles" style="background-color:Red; text-align:center;float:left">
                    {{ application.vinFraudReason }} </label>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="this.continue == 'Approval' || this.vincontinue == 'Approval'">
                  <label for="currentMiles" class="required">Fraud Managers Approval</label>
                </div>
                <div class="col-30" v-if="this.continue == 'Approval' || this.vincontinue == 'Approval'">
                  <input type="text" name="Approval Note" v-validate="'required'" @input="enableSubmit()"
                    data-vv-as="Approval Note" placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman"
                    v-model.trim="application.overrideFraud">
                  <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}</div>
                </div>
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3"
                  v-if="application.customerFraudReason == 'Review' && (this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <label for="currentMiles" class="required">Fraud Managers Approval</label>
                </div>
                <div class="col-30"
                  v-if="application.customerFraudReason == 'Review' && (this.continue == 'Approval' || this.vincontinue == 'Approval')">
                  <input type="text" name="Approval Note" v-validate="'required'" @input="enableSubmit()"
                    data-vv-as="Approval Note" placeholder="From: Jim Moscatello|Rich Bricker|Doug Goodman"
                    v-model.trim="application.overrideFraud">
                  <div v-if="errors.has('Approval Note')" class="alert-danger">{{ errors.first('Approval Note') }}</div>
                </div>
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="make" class="col-form-label col-form-label-sm "> Make </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" v-validate="'max:150'" data-vv-as="Make" class="form-control input-sm " name="make"
                    v-model.trim="application.make" placeholder="Enter Make">
                  <div v-if="errors.has('make')" class="alert-danger">{{ errors.first('make') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="model" class="col-form-label col-form-label-sm "> Model </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="model" v-validate="'max:150'" class="form-control input-sm "
                    data-vv-as="Model" v-model.trim="application.model" placeholder="Enter Model">
                  <div v-if="errors.has('model')" class="alert-danger">{{ errors.first('model') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="year" class="col-form-label col-form-label-sm "> Year </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="year" v-validate="'digits:4'" data-vv-as="Year"
                    class="form-control input-sm " v-model.trim="application.year" placeholder="Enter Year"
                    maxlength="4"
                    onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                  <div v-if="errors.has('year')" class="alert-danger">{{ errors.first('year') }}</div>
                </div><!--col end-->
              </div><!--row end-->

              <div id="myModal" class="modal">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>Fraud Alert</h2>
                  </div>
                  <div class="modal-body">
                    There is fraud block. To continue, override provide supervisor
                  </div>
                  <br>
                  <div class="modal-footer"><button class="btn-blue-save submitButton"
                      @click="fraudoverride()">OK</button>
                  </div>
                </div>
                <div id="reviewAlert" class="modal">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h2>Review Alert</h2>
                    </div>
                    <div class="modal-body">
                      There is fraud block. To continue, override provide supervisor
                    </div>
                    <br>
                    <div class="modal-footer"><button class="btn-blue-save nextButton"
                        @click="fraudoverride()">OK</button>
                    </div>
                  </div>
                </div>
              </div>
              <div id="vinDecoder" class="modal">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>No Vehicle Found</h2>
                  </div>
                  <div class="modal-body">
                    {{ vehicleInfoMessage }}
                  </div>
                  <br>
                  <div class="modal-footer"><button class="btn-blue-save nextButton" @click="clearVIN()">OK</button>
                  </div>
                </div>
              </div>

              <nav class="navbar navbar-expand-lg  bg-info text-white" v-if="customer != null"><span><b> Customer
                    Details</b></span>
              </nav>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="addressLine1" class="col-form-label col-form-label-sm "> Address Line1 </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="addressLine1" v-validate="'max:50'" data-vv-as="Address Line 1"
                    v-model.trim="customer.address.street1" class="form-control input-sm "
                    placeholder="Enter Address Line1">
                  <div v-if="errors.has('addressLine1')" class="alert-danger">{{ errors.first('addressLine1') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="addressLine2" class="col-form-label col-form-label-sm "> Address Line2 </label>
                </div><!--col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="addressLine2" v-validate="'max:50'" class="form-control input-sm "
                    data-vv-as="Address Line 2" v-model.trim="customer.address.street2"
                    placeholder="Enter Address Line2">
                  <div v-if="errors.has('addressLine2')" class="alert-danger">{{ errors.first('addressLine2') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="city" class="col-form-label col-form-label-sm "> City </label>
                </div><!--col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="city" v-validate="'max:50'" data-vv-as="City" class="form-control input-sm "
                    v-model.trim="customer.address.city" placeholder="Enter City">
                  <div v-if="errors.has('city')" class="alert-danger">{{ errors.first('city') }}</div>
                </div><!--col end-->
              </div><!--row end-->
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 " v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="stateCode" class="col-form-label col-form-label-sm "> State </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <multiselect style="width:100%" name="proposedLessee" v-model="selectedCustomerStateData"
                    :options="states" :value="states.stateFipsC" label="stateN"
                    @input="getCustomerStateDetails(selectedCustomerStateData.stateFipsC)" selected="selected"
                    id="customersdd">
                  </multiselect>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="country" class="col-form-label col-form-label-sm "> Country </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" data-vv-as="Country" v-validate="'max:40'" name="country"
                    v-model.trim="customer.address.country" class="form-control input-sm " disabled>
                  <div v-if="errors.has('country')" class="alert-danger">{{ errors.first('country') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="zip" class="col-form-label col-form-label-sm "> Zip Code </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="zip" data-vv-as="Zip Code" class="form-control input-sm " maxlength="5"
                    v-validate="{ regex: /^(\d)(?!\1+$)/, digits: 5 }" v-model.trim="customer.address.zipCode"
                    @input="zipDecoder" placeholder="Enter 5 Digit zip">
                  <div v-if="errors.has('zip')" class="alert-danger">{{ errors.first('zip') }}</div>
                </div><!--col end-->
              </div><!--row end-->
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="email" class="col-form-label col-form-label-sm "> Email </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="email" v-validate="'required|email'" class="form-control input-sm "
                    data-vv-as="Email" v-model.trim="customer.digitalContactInfo.email" placeholder="Enter EmailID"
                    maxlength="50">
                  <div v-if="errors.has('email')" class="alert-danger">{{ errors.first('email') }}</div>
                </div><!--col end-->
              </div><!--row end-->
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2" v-if="customer != null">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="workNumber" class="col-form-label col-form-label-sm "> Work Number </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="workNumber" v-validate="'min:10|max:15'" data-vv-as="Work Number"
                    v-model.trim="customer.digitalContactInfo.workNumber" @input="formatWorkPhoneNumber"
                    class="form-control input-sm " @blur="formatWorkPhoneNumber" placeholder="Enter Work Number">
                  <div v-if="errors.has('workNumber')" class="alert-danger">{{ errors.first('workNumber') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="mobileNumber" class="col-form-label col-form-label-sm "> Mobile Number </label>
                </div><!--col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <input type="text" name="mobileNumber" v-validate="'min:10|max:15'" class="form-control input-sm "
                    data-vv-as="Mobile Number" v-model.trim="customer.digitalContactInfo.mobileNumber"
                    @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber" placeholder="Enter Mobile Number">
                  <div v-if="errors.has('mobileNumber')" class="alert-danger">{{ errors.first('mobileNumber') }}</div>
                </div><!--col end-->
              </div><!--row end-->
            </div>
            <br>
            <div v-if="applicationtype === newapp || selectedquote != ''">
              <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b> Status</b></span></nav>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="changeApp" class="col-form-label col-form-label-sm required"> App Status </label>
                </div><!--col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-validate="'required'" name="changeApp" v-model.trim="application.applicationStatus"
                    class="form-control input-sm " data-vv-as="Status">
                    <option v-for="status in appStatusList" v-bind:value="status.value" v-bind:key="status.key"> {{
              status.value }}
                    </option>
                  </select>
                  <div v-if="errors.has('changeApp')" class="alert-danger">{{ errors.first('changeApp') }}</div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="declineCat" class="col-form-label col-form-label-sm required"
                    v-if="application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer'">
                    Decline Category </label>
                </div><!--col end-->
                <div class="col-12 col-md-12  justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <select v-validate="'required'" data-vv-as="Decline Category" class="form-control input-sm "
                    name="declineCat" v-model.trim="application.custdeclineCategorykey"
                    v-if="application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer'">
                    <option disabled value=""> Select Decline Category</option>
                    <option v-for="status in declineCustomerCategoryList" v-bind:value="status.value"
                      v-bind:key="status.key"> {{
              status.value }} </option>
                  </select>
                  <div v-if="errors.has('declineCat')" class="alert-danger">{{ errors.first('declineCat') }}</div>
                </div><!--col end-->
              </div><!--row end-->
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 "
                v-if="(application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer') && application.custdeclineCategorykey != 'Other'">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="declineReason" class="col-form-label col-form-label-sm"> Decline Reason </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <textarea v-model.trim="application.declineReason" name="declineReason" v-validate="'max:250'"
                    spellcheck="true" placeholder="Decline Reason"
                    v-if="application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer'"
                    rows="5" cols="20" style="width: 52.4%;" />
                </div><!--col end-->
              </div>
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 "
                v-if="(application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer') && application.custdeclineCategorykey == 'Other'">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="declineReason" class="col-form-label col-form-label-sm required"> Decline Reason </label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3 ">
                  <textarea v-model.trim="application.declineReason" data-vv-as="Decline Reason" name="declineReason"
                    v-validate="'required|max:250'" spellcheck="true" placeholder="Decline Reason"
                    v-if="application.applicationStatus == 'Declined By LLP' || application.applicationStatus == 'Declined By Customer'"
                    rows="5" cols="20" style="width: 52.4%;" />
                </div><!--col end-->
              </div><!-- row end-->
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                  <label for="dummy"> </label>
                </div><!--col end-->
                <div v-if="errors.has('declineReason')" class="alert-danger">{{ errors.first('declineReason') }}</div>
              </div><!--row end-->

            </div>
            <br>
            <div v-if="applicationtype === newapp || selectedquote != ''">
              <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 justify-content-center mb-3">
                <div class="center">
                  <button class="btn btn-secondary" type="submit" @click="saveapplicationdata">Submit</button>
                </div>
              </div>
            </div>
            <br><br>
          </div>
        </div>
        <!-- End of the code for this screen here -->
        <bottom-footer></bottom-footer>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeader from '@/components/TopHeader.vue'
import BottomFooter from '@/components/BottomFooter.vue'
import httpcommon from '../js/http-common.js'
import httpcustomer from '../js/http-customer.js'
import httpsource from '../js/http-managesource.js'
import httpdeal from '../js/http-dealstracking.js'
import httpemployee from '../js/http-employee.js'
import quotesjson from '../json/quotes.json'
import util from '../js/common-utils'
import moment from 'moment'
import lookup from '../prod-json/lookupvalues.json'

import MainMenu from '@/components/Menu.vue'
export default {
  components: {
    MainMenu,
    TopHeader,
    BottomFooter
  },
  name: 'addapplication',
  data () {
    return {
      quoteIdList: [],
      vehicleInfoMessage: '',
      selectedCustomerData: '',
      selectedEmployeeData: '',
      selectedCreditAnalystData: '',
      selectedDealerData: '',
      selectedCustomerStateData: '',
      selectedApplicationStateData: '',
      quoteNumbersList: [],
      selectedQuoteNumber: '',
      quoteCreditAnalystList: [],
      selectedCreditAnalystId: '',
      quoteAgentsList: [],
      selectedAgentId: '',
      quoteDealersList: [],
      selectedDealerId: '',
      selectedCustomerId: '',
      customerFraudReason: null,
      searchDealerFraudReason: null,
      quoteDealerStateList: [],
      quoteMakeList: [],
      quoteModelList: [],
      quoteCustomersList: [],
      quoteStatus: '',
      status: [
        { status: 'Open' },
        { status: 'Converted' }
      ],
      isLoading: false,
      quoteYear: '',
      quoteMake: '',
      quoteModel: '',
      selectedDealerState: '',
      fromDate: moment().subtract(60, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      application: this.initializedata(), // intialize application entry fields
      customer: null,
      continue: null,
      vincontinue: null,
      listQuotes: [],
      information: '',
      msgcolor: {
        color: 'black'
      },
      dealersList: [],
      dealClosingProbabilityPercentList: [
        { key: '1', value: '0' },
        { key: '2', value: '25' },
        { key: '3', value: '50' },
        { key: '4', value: '75' },
        { key: '5', value: '100' }
      ],

      inhouseList: [
        { inhouseValue: 'Dupont Registry' },
        { inhouseValue: 'Sports Car Markett' },
        { inhouseValue: 'Google' },
        { inhouseValue: 'Instagram' },
        { inhouseValue: 'Facebook' },
        { inhouseValue: 'Existing Customer' },
        { inhouseValue: 'Other' }
      ],
      agentList: [],
      creditAnalystList: [],
      currentPage: 1,
      totalPages: 0,
      perPage: 10,
      numberOfElements: 0,
      totalElements: 0,
      applicationtype: '',
      newapp: 'newapp',
      convertQuote: 'convertQuote',
      selectedquote: '',
      states: [],
      sources: [
        { sourceName: 'Dealer' },
        { sourceName: 'InHouse' }
      ],
      customersList: [],
      heads: [
        { name: 'Select' },
        { name: 'Lessee Name' },
        { name: 'Bussiness Contact Name' },
        { name: 'Customer Fraud Reason' },
        { name: 'Quote Generated Date' },
        { name: 'Quote Number' },
        { name: 'Make' },
        { name: 'Model' },
        { name: 'Loan Amount' },
        { name: 'Dealer Name' }
      ],
      fraudMobileError: '',
      appStatusList: lookup[0].lookupValues,
      fraudMobileError: '',
      declineCustomerCategoryList: lookup[2].lookupValues
    }
  },
  methods: {
    displayCustomerFullName (option) {
      if (option.customerType == 'P') {
        return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
      } else if (option.customerType == 'B') {
        return `${option.businessName}`
      }
    },
    displayFullName (option) {
      return `${option.firstName} ${option.middleName != null && option.middleName.length != 0 ? ',' + option.middleName : ''} ,${option.lastName != null && option.lastName.length != 0 ? option.lastName : ''}`
    },
    formatCellPhoneNumber: function (event) {
      var phone = this.customer.digitalContactInfo.mobileNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.digitalContactInfo.mobileNumber = phone
      this.getCustomerMobileFraud()
    },
    formatWorkPhoneNumber: function (event) {
      var phone = this.customer.digitalContactInfo.workNumber
      phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
      this.customer.digitalContactInfo.workNumber = phone
    },
    myFunction () {
      var elmnt = document.getElementById('height2')
      var elmnt1 = document.getElementById('height3')
      var txt = elmnt.offsetHeight
      var width = elmnt.offsetWidth
      var txt1 = elmnt1.offsetHeight
      var ht = txt + txt1
      $('#deals').css('margin-top', txt + txt1 + 3)
    },
    menuheight () {
      var elmnt = document.getElementById('height2')
      var txt = elmnt.offsetHeight
      $('#height3').css('margin-top', txt)
    },
    getCustomerMobileFraud () {
      if (this.customer.digitalContactInfo.mobileNumber != '') {
        httpcustomer.get('/customer/checkfraudMobileNumber/' + this.customer.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, '')).then(response => {
          if (response.data == 'Y') {
            this.fraudMobileError = 'The given MobileNumber is blocked'
          } else {
            this.fraudMobileError = ''
          }
        })
      }
    },
    zipDecoder () {
      if (this.customer.address.zipCode.length == 5) {
        httpcommon.get('/statefip/zipCode/' + this.customer.address.zipCode)
          .then(response => {
            if (response.data.city != null) {
              this.customer.address.city = response.data.city
            } else {
              this.customer.address.city = ''
            }
            if (response.data.city != null) {
              this.getCustomerStateDataDetails(response.data.state)
            } else {
              this.selectedCustomerStateData = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getCustomerStateDataDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          this.selectedCustomerStateData = this.states[i]
        }
      }
    },
    getVehicleInfo (vin) {
      httpdeal.get('/quote/getVechicleInfo/' + vin).then(response => {
        if (response.data[0].year == null && response.data[0].make == null && response.data[0].model == null && response.data[0].trim == null) {
          httpdeal.get('/quote/getVechicleInfoMessage').then(response => {
            this.vehicleInfoMessage = response.data
          })
          var modal = document.getElementById('vinDecoder')
          modal.style.display = 'block'
          this.application.year = ''
          this.application.make = ''
          this.application.model = ''
        } else {
          this.application.year = response.data[0].year
          this.application.make = response.data[0].make
          this.application.model = response.data[0].model
        }
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    clearVIN () {
      var modal = document.getElementById('vinDecoder')
      modal.style.display = 'none'
      this.vehicleInfoMessage = ''
    },
    getVinFraudReason (vin) {
      if (this.application.vinNumber.length >= 6) {
        this.getVehicleInfo(this.application.vinNumber)
        httpcustomer.get('customer/getVinFraudDetails?vin=' + vin).then(response => {
          if (response.data.length == 0 || response.data[0].vinFraudReason == null) {
            this.vincontinue = null
            this.application.vinFraudReason = null
            document.getElementById('submitbutton').disabled = true
          }
          if (response.data.length != 0 && response.data[0].vinFraudReason != null) {
            this.application.vinFraudReason = response.data[0].vinFraudReason
            if (this.application.vinFraudReason != null && this.application.overrideFraud == null) {
              var modal = document.getElementById('myModal')
              modal.style.display = 'block'
              this.vincontinue = 'Approval'
              document.getElementById('submitbtn').disabled = false
            } else if (this.application.vinFraudReason != null && this.application.overrideFraud != null) {
              this.vincontinue = 'Approval'
              document.getElementById('submitbtn').disabled = false
            } else {
              document.getElementById('submitbutton').disabled = true
            }
          }
        })
          .catch(e => {
            console.log(e)
            this.errors.push(e)
          })
      } else {
        this.application.vinFraudReason = null
        this.vincontinue = null
        if (this.application.vinFraudReason == null && this.application.customerFraudReason == null) {
          this.application.overrideFraud = null
        }
        document.getElementById('submitbutton').disabled = false
      }
    },
    fraudoverride () {
      if (this.application.customerFraudReason != null) {
        if (this.application.customerFraudReason != 'Review') {
          this.continue = 'Approval'
          var modal = document.getElementById('myModal')
          modal.style.display = 'none'
        } else {
          this.continue = 'Approval'
          var modal = document.getElementById('reviewAlert')
          modal.style.display = 'none'
          document.getElementById('submitbutton').disabled = false
        }
      } else if (this.application.vinFraudReason != null) {
        this.vincontinue = 'Approval'
        var modal = document.getElementById('myModal')
        modal.style.display = 'none'
      }
    },

    enableSubmit () {
      if (this.quote.overrideFraud != null && this.quote.overrideFraud.length > 0) {
        document.getElementById('submitbutton').disabled = false
      } else {
        document.getElementById('submitbutton').disabled = true
      }
    },

    populateQuoteValues: function (quoteId, index) {
      // console.log('Quotes DATA : ' + JSON.stringify(this.listQuotes[index]))
      httpdeal.get('/quote/OpenQuotes/' + quoteId).then(response => {
        this.quoteIdList = response.data
        this.application.model = this.quoteIdList[0].lmModel
        this.application.make = this.quoteIdList[0].lmMake
        this.application.year = this.quoteIdList[0].lmYear
        this.application.vinNumber = this.quoteIdList[0].lmVin
        this.application.loanamount = this.quoteIdList[0].lmLoanAmount
        this.application.stateCode = this.quoteIdList[0].deStateOfRegistration
        this.application.source = this.quoteIdList[0].lmSource
        this.application.proposedLesseeName = this.quoteIdList[0].lmProposedLesseeName
        this.application.selectedCustomerId = this.quoteIdList[0].customerId
        this.application.selectedEmployeeId = this.quoteIdList[0].employeeId// added to populate Salesperson name
        this.application.selectedDealerId = this.quoteIdList[0].dealerId // added to populate dealer name
        this.application.inHouseName = this.quoteIdList[0].inhouseCategory
        this.application.overrideFraud = this.quoteIdList[0].overrideFraud
        this.getCustomerDetails(this.quoteIdList[0].customerId)
        this.getAgentDetails(this.quoteIdList[0].employeeId, 'SR')
        if (this.quoteIdList[0].creditAnalystId > 0) {
          this.getAgentDetails(this.quoteIdList[0].creditAnalystId, 'CA')
        }
        this.getDealerDetails(this.quoteIdList[0].dealerId)
        // this.getFraudCustomer(this.quoteIdList[0].customerId)
        this.getVinFraudReason(this.quoteIdList[0].lmVin)
        this.updateDealer(this.quoteIdList[0].employeeId)
        // this.getApplicationStateDetails(this.listQuotes[index].deStateOfRegistration);
        this.errors.clear()
        this.$validator.reset()
        this.application.dealClosingProbabilityPercent = 0
      })
        .catch(e => {
          this.$set(this.errors, 'field', e);
          // this.errors.push(e)
        })
    },
    updateDealer (employeeId) {
      this.dealersList = []

      if (this.application.source == 'InHouse') {
        httpsource.get('/dealersearch').then(response => {
          if (response.data.length != 0) {
            this.dealersList = []
            this.dealersList = response.data
          }
        })
          .catch(error => {
            console.log('Failed to load dealers:' + error)
          })
      } else if (employeeId != undefined) {
        httpemployee.get('/employee/' + parseInt(employeeId)).then(response => {
          this.dealersList = []
          for (var i = 0; i < response.data.length; i++) {
            var employeeobject = response.data[i]
            for (var i = 0; i < employeeobject.empBusinessCoverageAreas.length; i++) {
              var empbuscovarea = employeeobject.empBusinessCoverageAreas[i]
              this.dealersList.push({
                'dealerId': empbuscovarea.id.dealerId,
                'dealerName': empbuscovarea.ddealerInfo.dealerName
              })
            }
          }
        }).catch(e => { console.log(e) })
      }
    },
    colorRow: function (quoteNumber) {
      if (quoteNumber === this.selectedquote) { return 'selected-quote' } else { return 'non-selected-quote' }
    },
    resetEntries: function (e) {
      this.selectedDealerId = ''
      this.selectedCustomerId = ''
      this.fromDate = moment().subtract(60, 'days').format('YYYY-MM-DD')
      this.toDate = moment().format('YYYY-MM-DD')
      this.quoteYear = ''
      this.quoteMake = ''
      this.quoteModel = ''
      this.quoteStatus = ''
      this.selectedAgentId = ''
      this.selectedCreditAnalystId = ''
      this.selectedQuoteNumber = ''
      this.customerFraudReason = null
      this.searchDealerFraudReason = null
      this.information = ''
      this.quoteMessage = ''
      this.selectedquote = ''
      this.quoteSearch = ''
      this.selectedDealerState = ''
      // this.quote = this.initializedata()
      // this.quotesSearch()
      this.$validator.reset()

      this.customer = null

      if (this.listQuotes.length == 0 && this.applicationtype === 'newapp') {
        this.information = 'No Quotes available in the system'
        this.msgcolor.color = 'Red'
      } else {
        this.information = ''
        this.msgcolor.color = ''
      }
      this.application = this.initializedata()
      this.selectedCustomerData = ''
      this.selectedEmployeeData = ''
      this.selectedCreditAnalystData = ''
      this.selectedDealerData = ''
      this.selectedCustomerStateData = ''
      this.selectedApplicationStateData = ''
    },
    getFraudCustomer (customerId) {
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
        if (response.data.length && response.data[0].customerFraudReason && response.data[0].customerFraudReason != '' && response.data[0].customerFraudReason != undefined) {
          this.application.customerFraudReason = response.data[0].customerFraudReason
          if (this.application.customerFraudReason != null && this.application.overrideFraud == null) {
            if (this.application.customerFraudReason != 'Review') {
              var modal = document.getElementById('myModal')
              modal.style.display = 'block'
              document.getElementById('submitbutton').disabled = false
            } else {
              var modal = document.getElementById('reviewAlert')
              modal.style.display = 'block'
              document.getElementById('submitbutton').disabled = true
            }
          } else if (this.application.customerFraudReason != null && this.application.overrideFraud != null) {
            this.continue = 'Approval'
            document.getElementById('submitbutton').disabled = false
          }
        } else {
          this.application.customerFraudReason = null
          if (this.application.vinFraudReason == null && this.application.customerFraudReason == null) {
            this.application.overrideFraud = null
          }
          this.application.customerFraudReason = null
          this.continue = null
          if(document.getElementById('submitbutton')) document.getElementById('submitbutton').disabled = false
        }
      }).catch(e => {
                console.log(e);
              })
    },

    fetchData () {
      this.retrieveQuoteCustomerList()
      // this.retrieveQuotes()
      this.retriveQuoteYearList()
      this.retriveQuoteMakeList()
      this.retrieveStateList()
      this.retrieveCustomerList()

      this.retrieveAgentList()
      this.retriveQuoteNumbersList()
      // this.retriveQuoteEmployeeList()
      this.retriveQuoteModelList()
      this.retrieveQuoteDealerList()
      this.retriveQuoteDealerStateList()
    },

    saveapplicationdata () {
          var quoteId = ''
          if (this.applicationtype == 'convertQuote') {
            quoteId = this.selectedquote
          }

          let newapplication = {
            "creationUserI": this.$session.get("user_id"),
            "appDate": util.formatDateJS(this.application.appDate),
            "lastUpdatedUserI": this.$session.get("user_id"),
            "make": this.application.make,
            "model": this.application.model,
            "year": this.application.year,
            "vin": this.application.vinNumber,
            "loanAmount": this.application.loanamount,
            "overrideFraud": this.application.overrideFraud,
            "source": this.application.source,
            "quoteState": this.selectedApplicationStateData.stateAlphaC,
            "inhouseCategory": this.application.inHouseName,
            "salesAgent": this.selectedEmployeeData.employeeId,
            "creditAnalystId": this.selectedCreditAnalystData.employeeId,
            "quoteId": quoteId,
            "customerId": this.selectedCustomerData.customerId,
            "dealerId": this.selectedDealerData.dealerId,
            "dealClosingProbabilityPercent": this.application.dealClosingProbabilityPercent,
            "appStatus": this.application.applicationStatus,
            "appDeclineCategory": this.application.appDeclineCategory,
            "appDeclineReason": this.application.appDeclineReason
          }
          if (this.fraudMobileError == '') {
            httpdeal.post('/application/addapplication/', newapplication).then(response => {
              var status = response.data
              if (status == 'CREATED') {
                this.information = 'Application Successfully added into the system'
                this.msgcolor.color = 'Blue'
                this.savecustomerdata()
                this.application = this.initializedata()
                this.quotesSearch()
                this.selectedquote = ''
                this.customer = null
                this.selectedCustomerData = ''
                this.selectedEmployeeData = ''
                this.selectedCreditAnalystData = ''
                this.selectedDealerData = ''
                this.selectedApplicationStateData = ''
              } else {
                this.msgcolor.color = 'Red'
                this.information = 'Could not create Application....'
              }
            })
              .catch(e => {
                this.msgcolor.color = 'Red'
                this.information = '' || e.name || e.message
              })
          }
    },
    savecustomerdata () {
      this.customer.digitalContactInfo.mobileNumber = this.customer.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, ''),
      this.customer.digitalContactInfo.workNumber = this.customer.digitalContactInfo.workNumber.replace(/[^0-9]/g, ''),
      httpcustomer.put('/customer/', this.customer).then(response => {
        var status = response.data
        if (status == 'ACCEPTED') {
          this.customer = []
          this.selectedCustomerData = ''
        }
      })
        .catch(e => {
          console.log(e)
        })
    },
    retrieveQuotes () {
      httpdeal.get('/quote/').then(response => {
        if (response.data[0].errorMessage != null && response.data[0].errorMessage.length > 0) {
          this.listQuotes = []
          if (this.applicationtype === 'convertQuote') {
            this.information = 'No Quotes available in the system'
            this.msgcolor.color = 'Red'
          }
        } else {
          var arr = []
          var j = 0
          var fraudreason = []
          var listApps1 = []
          var listApps1 = response.data

          for (var i = 0; i < listApps1.length; i++) {
            arr.push(listApps1[i].customerId)
          }
          httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
            fraudreason = response.data
            for (j = 0; j < listApps1.length; j++) {
              for (var k = 0; k < fraudreason.length; k++) {
                if (listApps1[j].customerId == fraudreason[k].customerId) {
                  if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                }
              }
            }
            this.listQuotes = listApps1
          })
        }
      })

        .catch(e => {
          console.log(e)
        })
    },
    createSearchObject () {
      return {
        'firstName': '',
        'lastName': '',
        'roleType': '',
        'statusCode': 'A'
      }
    },
    retrieveAgentList () {
      let searchEmployee = this.createSearchObject()
      httpemployee.post('/employee/search/', searchEmployee).then(response => {
        if (response.data.length > 0) {
          // this.agentList = response.data.filter((employee) => {
          //   return employee.userRoleC !== 'CA'
          // })
          // this.creditAnalystList = response.data.filter((employee) => {
          //   return employee.userRoleC === 'CA'
          // })
          this.agentList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'SR');
          })
          this.creditAnalystList = response.data.filter((employee) => {
            return employee.userRoles && Array.isArray(employee.userRoles) && 
            employee.userRoles.some(role => role.userRoleC === 'CA');
          })
        }
      })
        .catch(e => {
          this.errors.push(e)
        })
    },

    retrieveStateList () {
      httpcommon.get('/statefip/').then(response => {
        this.states = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    retrieveCustomerList () {
      httpcustomer.get('/customer/').then(response => {
        this.customersList = response.data
      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCustomerDetails (customerId) {
      this.getFraudCustomer(customerId)
      if (customerId.length != 0) {
        httpcustomer.get('/customer/' + customerId).then(response => {
          var customerlist = response.data
          var customerobject = customerlist[0]
          this.selectedCustomerData = customerlist[0]
          if (customerobject.customerId == customerId) {
            this.customer = customerobject
            this.getCustomerStateDetails(this.customer.address.stateFipsC)
            this.customer.digitalContactInfo.mobileNumber = customerobject.digitalContactInfo.mobileNumber.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
            this.customer.digitalContactInfo.workNumber = customerobject.digitalContactInfo.workNumber.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
          }
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getAgentDetails (employeeId, role) {
      if (employeeId >= 0) {
        httpemployee.get('/employee/' + employeeId).then(response => {
          var employeelist = response.data
          if (role === 'SR') {
            this.selectedEmployeeData = employeelist[0]
          }
          if (role === 'CA') {
            this.selectedCreditAnalystData = employeelist[0]
          }
          // console.log("ID : " + JSON.stringify(this.selectedEmployeeData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getDealerDetails (dealerId) {
      if (dealerId >= 0) {
        httpsource.get('/dealerbyid/' + dealerId).then(response => {
          var dealerlist = response.data
          this.selectedDealerData = dealerlist
          // console.log("ID : " + JSON.stringify(this.selectedDealerData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },
    getCustomerStateDetails (stateFipsC) {
      //  console.log("Customer Object : " + stateFipsC)
      if (stateFipsC >= 0) {
        httpcommon.get('/statefip/' + stateFipsC).then(response => {
          var customerstatelist = response.data
          this.selectedCustomerStateData = customerstatelist[0]
          // console.log("State FIPS ID : " + JSON.stringify(this.selectedCustomerStateData))
        })
          .catch(e => {
            this.errors.push(e)
          })
      }
    },

    changeDealer (event) {
      for (var i = 0; i < this.agentList.length; i++) {
        if (this.agentList[i].employeeId == event.target.value) {
          this.application.modifieldSalesAgentID = this.agentList[i].firstName + ' ' + this.agentList[i].middleName + ' ' + this.agentList[i].lastName
        }
      }
    },
    changeCustomer (event) {
      var list = document.getElementById('customersList')
      var found = false
      for (var i = 0; i < list.options.length; i++) {
        if (list.options[i].value === event.target.value) {
          this.selectedCustomerData.customerId = list.options.item(i).label
          found = true
          this.getCustomerDetails(this.selectedCustomerData.customerId)
          break
        }
      }
      if (!found) {
        this.selectedCustomerData.customerId = ''
        this.clearCustomerDetails()
      }
    },
    clearCustomerDetails () {
      this.application.addressLine1 = ''
      this.application.addressLine2 = ''
      this.application.city = ''
      this.application.selectedStateCode = ''
      this.application.country = ''
      this.application.zipcode = ''
      this.application.email = ''
      this.application.workNumber = ''
      this.application.mobileNumber = ''
    },
    retrieveDealersList () {
      httpsource.get('/dealersearch').then(response => {
        this.dealersList = response.data
      })
        .catch(error => {
          console.log('Failed to load dealer list dropdown:' + error)
          this.errors.push(e)
        })
    },
    
  // filter section
  async quotesSearch () {
      this.listQuotes = []
      this.isLoading = true
      var employeeId1
      var creditAnalystId1
      var dealerId1
      var customerId1
      var stateId1
      if (this.selectedAgentId != '') {
        employeeId1 = this.selectedAgentId.employeeId
      } else {
        employeeId1 = this.selectedAgentId
      }
      if (this.selectedCreditAnalystId != '') {
        creditAnalystId1 = this.selectedCreditAnalystId.employeeId
      } else {
        creditAnalystId1 = this.selectedCreditAnalystId
      }
      if (this.selectedDealerId != '') {
        dealerId1 = this.selectedDealerId.dealerId
      } else {
        dealerId1 = this.selectedDealerId
      }
      if (this.selectedCustomerId != '') {
        customerId1 = this.selectedCustomerId.customerId
      } else {
        customerId1 = this.selectedCustomerId
      }
      if (this.selectedDealerState != '') {
        stateId1 = this.selectedDealerState.stateId
      } else {
        stateId1 = this.selectedDealerState
      }
      var frmDt, toDt
      if (this.fromDate != '') { frmDt = util.formatDateMoment(moment(this.fromDate)) } else { frmDt = this.fromDate }
      if (this.toDate != '') { toDt = util.formatDateMoment(moment(this.toDate)) } else { toDt = this.toDate }

      // this.$validator.validateAll().then(async () => {
      //   if (!this.errors.any()) {
          if (this.quoteStatus === 'All') {
            this.quoteStatus = ''
          }
          const payload = {
        "quoteNumber": this.selectedQuoteNumber || "",
        "fromDate": this.fromDate || null,
        "toDate": this.toDate || null,
        // "fromDate": "2024-11-10",
        // "toDate": "2024-11-19",
        "salesRepId": this.selectedAgentId.employeeId || null,
        "dealerId": this.selectedDealerId.dealerId || null,
        "customerId": this.selectedCustomerId.customerId || null,
        "dealerState": this.selectedDealerState.stateFipsC || "",
        "make": this.quoteMake || "",
        "year": this.quoteYear || null,
        "model": this.quoteModel || "",
        "quoteStatus": this.quoteStatus || "",
        "creditAnalystId": this.selectedCreditAnalystId.employeeId || null
        }
      await httpdeal.post('/quote/SearchQuote', payload, {params: {'page' : this.currentPage - 1, 'size': 10}}).then(async response => {
            if (response.data.content.length == 0) {
              this.listQuotes = []
              this.information = 'No Quotes available in the system with the provided search criteria'
              this.msgcolor.color = 'Red'
              if (this.quoteStatus == '') {
                this.quoteStatus = 'All'
              }
              this.quote = this.initializedata()
            } else {
              this.information = ''
              var arr = []
              var j = 0
              var fraudreason = []
              var listApps1 = []
              listApps1 = response.data.content

              for (var i = 0; i < listApps1.length; i++) {
                arr.push(listApps1[i].customerId)
                listApps1[i]['dealerFraudreason'] = listApps1[i].lmDealerName != null ? await this.getFraudDealerReason(listApps1[i].lmDealerName) : null
              }
              await httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + arr).then(response => {
                fraudreason = response.data
                for (j = 0; j < listApps1.length; j++) {
                  for (var k = 0; k < fraudreason.length; k++) {
                    if (listApps1[j].customerId == fraudreason[k].customerId) {
                      if (fraudreason[k].customerFraudReason != '') { listApps1[j]['fraudreason'] = fraudreason[k].customerFraudReason } else { listApps1[j]['fraudreason'] = null }
                    }
                  }
                }
                this.listQuotes = listApps1
              })
              
              this.totalPages =  response.data.totalPages
              this.numberOfElements = response.data.numberOfElements;
              this.totalElements = response.data.totalElements
              if (this.quoteStatus == '') {
                this.quoteStatus = 'All'
              }
            }
            this.quote = this.initializedata()
            this.selectedquote = ''
            this.isLoading = false
          })
            .catch(e => {
              console.log(e)
              this.isLoading = false
            })
    },

    async getFraudDealerReason (dealer) {
      const dealerData = {
        dealerName: dealer
      }
      try {
        const response = await httpsource.post('/fraudDealerDetails', dealerData)
        if (response.data.length > 0) {
          return response.data[0].dealerFlagReason
        } else {
          return null // Return null if no data is found
        }
      } catch (e) {
        this.errors.push(e)
        return null // Return null if there's an error
      }
    },

  retriveQuoteNumbersList () {
      httpdeal.get('/quote/quoteNumber').then(response => {
        this.quoteNumbersList = response.data
      })
    },
    async retrieveQuoteCustomerList () {
      await httpdeal.get('/quote/quotecustomers').then(response => {
        this.quoteCustomersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errors.push(e)
        })
    },
    // retriveQuoteEmployeeList () {
    //   httpdeal.get('/quote/quoteemployees').then(response => {
    //     if (response.data.length > 0) {
    //       this.quoteAgentsList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'SR'
    //       })
    //       this.quoteCreditAnalystList = response.data.filter((employee) => {
    //         return employee.userRoleC == 'CA'
    //       })
    //     }
    //   })
    // },
    
    retrieveQuoteDealerList () {
      httpdeal.get('/quote/quotedealers').then(response => {
        this.quoteDealersList = response.data
      })
        .catch(e => {
          console.log(e)
          this.errorlist.push(e)
        })
    },

    resetEntriesAndSearch() {
      this.resetEntries();
      this.quotesSearch();
    },

    getFraudLessee (customerId) {
      this.customerFraudReason = null
      httpdeal.get('/quote/dealsTrackingFraudCustomer?customerId=' + parseInt(customerId)).then(response => {
        if (response.data.length > 0) {
          console.log('fraud reason data', response)
          if (response.data[0].customerFraudReason != null) {
            this.customerFraudReason = response.data[0].customerFraudReason
            this.quote.LesseeFraudReason = response.data[0].customerFraudReason
          }
        } else {
          this.customerFraudReason = null
          this.quote.LesseeFraudReason = null
        }
      })
    },

    retriveQuoteYearList () {
      httpdeal.get('/quote/quoteyears').then(response => {
        this.quoteYearList = response.data
      })
    },
    
    retriveQuoteMakeList () {
      httpdeal.get('/quote/quotemake').then(response => {
        this.quoteMakeList = response.data
      })
    },

    retriveQuoteDealerStateList () {
      httpdeal.get('/quote/quotedealerstate').then(response => {
        this.quoteDealerStateList = response.data
      })
    },
    
    retriveQuoteModelList () {
      httpdeal.get('/quote/quotemodel').then(response => {
        this.quoteModelList = response.data
      })
    },
    
    displayDealerFullName (option) {
      return `${option.dealerName}`
    },
    
    displayStateFullName (option) {
      return `${option.stateN}`
    },

    handleClick (event) {
      this.currentPage = event
      this.quotesSearch()
    },

    initializedata () {
      return {
        salesAgent: '',
        dealClosingProbabilityPercent: 0,
        inHouseName: '',
        stateCode: '',
        make: '',
        model: '',
        vinNumber: '',
        appDate: new Date(),
        year: '',
        loanamount: 0,
        modifieldSalesAgentID: '',
        modifieldSalesAgentIDName: '',
        selectedCustomerId: '',
        selectedEmployeeId: '',
        selectedDealerId: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        selectedStateCode: '',
        stateCode: '',
        country: 'USA',
        zipcode: '',
        email: '',
        workNumber: '',
        mobileNumber: '',
        applicationStatus: 'Open',
        overrideFraud: null,
        custdeclineCategorykey: '',
        declineReason: '',
        customerFraudReason: null,
        vinFraudReason: null

      }
    },

  },
  created () {
    window.addEventListener('resize', this.myFunction)
    window.addEventListener('resize', this.menuheight)
  },
  mounted () {
    this.fetchData()
    this.myFunction()
    this.menuheight()
  },
  filters: {
    formatCustType (customerType) {
      if (customerType == '') {
        return 'Personal/Business'
      } else if (customerType == 'B') {
        return 'Business'
      } else if (customerType == 'P') {
        return 'Personal'
      }
    }
  },
  computed: {
    sortedDealers: function () {
      return this.dealersList.sort((a, b) => { return a.dealerName > b.dealerName ? 1 : -1 })
    },
    customerType: function () {
      var custSelect = this.selectedCustomerData.customerId
      var custType = ''
      if (this.selectedCustomerData.customerId != '') {
        this.customersList.forEach(customerObj => {
          if (customerObj.customerId == custSelect) {
            custType = customerObj.customerType
          }
        })
      }
      return custType
    }
  },
}
</script>
<style scoped>
.selected-quote {
  background: lightsalmon;
}

.non-selected-quote {
  background: lightgray;
}

.submitButton {
  width: 80px;
}

.required:after {
  content: " *";
}

.wrap-text {
  white-space: nowrap;
}

.nextButton {
  margin: 0px;
  padding: 0px;
  border-radius: 6px;
  font-size: 10px;
  height: 30px;
  width: 100px;
}

thead {
  position: sticky;
  top: 0px;
  /* 0px if you don't have a navbar, but something is required */

}
</style>
